function getControls() {
    const scanAgainButton = document.getElementById('scanAgainButton');

    return {
        scanAgainButton
    };
}

window.addEventListener('offline', updateOfflineStatus);
window.addEventListener('online', updateOnlineStatus);

function updateOfflineStatus() {
    const { scanAgainButton } = getControls();

    if (scanAgainButton) {
        scanAgainButton.disabled = true;
    }
}

function updateOnlineStatus() {
    const { scanAgainButton } = getControls();

    if (scanAgainButton) {
        scanAgainButton.disabled = false;
    }
}
